import { useBuilderWidget } from 'components/TasksV2/TaskCreation/contexts/BuilderWidgetContext'
import { BuilderSubtaskSettings } from 'components/TasksV2/TaskCreation/components/BuilderSubtaskSettings'
import WidgetHeader from 'components/TasksV2/UI/WidgetHeader'
import { WidgetWrapper } from 'components/TasksV2/UI/WidgetWrapper'
import React, { memo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, PseudoBox } from '@chakra-ui/core'
import { VideoQuestion } from './VideoQuestion'
import { useWidgetErrorMessage } from '../../useWidgetErrorMessage'
import { WidgetProps } from '../types'
import { WidgetIsRequiredSwitch } from '../WidgetIsRequiredSwitch'
import { VideoDescription } from './VideoDescription'
import { ImageMediaGallery } from '../Image/ImageMediaGallery'
import colors from 'constants/colors'

const VideoWidget: React.FC<WidgetProps> = memo(({ index, isDragging, field, remove, subtaskPath }) => {
  const builder = useBuilderWidget()
  const { control, errors } = useFormContext()

  const questionName = `${subtaskPath}.title`

  const videoError = useWidgetErrorMessage({ errors, index, field })

  return (
    <WidgetWrapper pos="relative" p="10px" isDragging={isDragging} isError={!!videoError} errorMessage={videoError}>
      <WidgetHeader onRemove={remove} subtaskType={field?.type} />

      <VideoQuestion questionName={questionName} field={field} />

      {!builder && <WidgetIsRequiredSwitch subtaskPath={subtaskPath} />}

      <PseudoBox
        className={builder ? 'creation-media-fields' : undefined}
        border="1px solid"
        borderColor={colors.greyBorder}
        borderRadius="8px"
        _focus={{ borderColor: '#f5f5f5', boxShadow: '0 0 0 1px #f5f5f5' }}
      >
        <VideoDescription subtaskPath={subtaskPath} />
        <ImageMediaGallery subtaskPath={subtaskPath} enableEdit={true} />
      </PseudoBox>
      {builder && <BuilderSubtaskSettings subtaskPath={subtaskPath} defaultCategory={field.category} />}

      {/* Register constant values in the form context */}
      <Controller
        name={`${subtaskPath}.type`}
        control={control}
        as={<Box />}
        key={`${subtaskPath}.type`}
        defaultValue={field?.type}
      />
    </WidgetWrapper>
  )
})

export default VideoWidget
